import { OidcProvider } from "contexts/OidcContext";
import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./App.scss";

const element = document.querySelector("#app");
createRoot(element).render(
  <OidcProvider>
    <App />
  </OidcProvider>,
);
